/**
 * FlaskSystem#draw: hands the system's bodies, tweens and geometry to the renderer
 * (FlaskRenderer unless the system was given another). Callers add `playfield`,
 * `worldOrigin`, `animTime` (pause-aware seconds) and `juice` through `renderOpts`.
 *
 * The old merge flash, merge burst and drop splash data (system.mergeFlash*, mergeParticles*,
 * dropSplash*) is no longer passed: the cartoon juice (render/juice) draws those moments, and
 * FlaskRenderer reads none of it.
 */
import * as C from "../../config/constants.js";
import { FlaskRenderer } from "../flask-renderer.js";

export function drawSystem(system, ctx, renderOpts) {
  system.ensureEngine();
  var renderer = system.opts.renderer || FlaskRenderer;
  var extraOpts = renderOpts || {};
  if (renderer && renderer.draw) {
    renderer.draw(ctx, Object.assign({
      bounds: system.bounds,
      bodies: system.bodies,
      bodyRadiusByTier: system.bodyRadiusByTier,
      evolutionChain: system.evolutionChain,
      mergeMotionDraw: system.mergeMotionDraw,
      // Read-only: the renderer derives each merging body's squash-stretch pose from the tween.
      activeMergeMotions: system.activeMergeMotions || null,
      shrinkMotionDraw: system.shrinkMotionDraw,
      flaskWallThickness: system.flaskWallThickness,
      flaskGeometry: system._flaskGeometry,
      mouthSealBody: system.mouthSealBody,
      tierColors: C.MERGE_PICKUP_COLORS || [],
    }, extraOpts));
  }
}
